/**
 * 删除指定的DOM元素
 * 
 * 此函数旨在从DOM中删除传入的元素它首先检查元素是否具有remove方法，
 * 如果有，则调用该方法如果没有，则找到元素的父节点并使用removeChild方法删除元素
 * 这种方法的多样性确保了较好的兼容性，即使在某些浏览器中元素没有直接的remove方法
 * 
 * @param element 要删除的DOM元素
 */
const _removeNode = (element: Element) => {
  if (element.remove) {
    element.remove()
  } else {
    element.parentNode?.removeChild(element)
  }
}


/**
 * 删除指定的DOM节点
 * 
 * 此函数支持传入选择器字符串、单个DOM元素或 NodeList 对象，从而灵活地删除一个或多个DOM节点
 * 它统一了删除DOM节点的逻辑，提高了代码的可读性和复用性
 * 
 * @param target - 可以是选择器字符串，单个 Element 或 NodeList 对象，表示要删除的DOM节点
 */
export const removeNode = (target: string | Element | NodeListOf<Element> |  null | undefined) => {
  if (!target) return
  
  // 当目标是一个选择器字符串时，找到所有匹配的元素并逐个删除
  if (typeof target === "string") {
    document.querySelectorAll(target).forEach(elem => {
      _removeNode(elem)
    })
  }
  // 当目标是 NodeList 对象时，遍历 NodeList 并逐个删除元素
  else if (target instanceof NodeList) {
    target.forEach(elem => {
      _removeNode(elem)
    })
  } 
  // 当目标是单个 DOM 元素时，直接删除该元素
  else {
    _removeNode(target)
  }
}